import { LabelKeyObject } from "react-csv/lib/core";

export const csvHeadersRides: LabelKeyObject[] = [
  {
    label: "Id",
    key: "id",
  },
  {
    label: "Date",
    key: "rideStart",
  },
  {
    label: "Status",
    key: "status",
  },
  {
    label: "Price",
    key: "price",
  },
  {
    label: "Direction",
    key: "direction",
  },
  {
    label: "Remarks",
    key: "metadata.remarks",
  },
  {
    label: "Site",
    key: "siteName",
  },
  {
    label: "Origin",
    key: "originStationName",
  },
  {
    label: "Destination",
    key: "destinationStationName",
  },
  {
    label: "Number of passengers",
    key: "metadata.seatsCount",
  },
  {
    label: "Distance",
    key: "metadata.totalDistance",
  },
  {
    label: "Duration",
    key: "metadata.totalDuration",
  },
  {
    label: "Supplier",
    key: "supplierName",
  },
  {
    label: "Vehicle",
    key: "vehicleName",
  },
  {
    label: "Ride Type",
    key: "rideTypeName",
  },
  {
    label: "Driver",
    key: "driverName",
  },
  {
    label: "Occupancy",
    key: "occupancy",
  },
];
